import { IMiningPlanOptions } from "@services/getMinerList";

import {
  ActionBaseMiningPlans,
  ActionSetMiningPlans,
  ActionUpdateMiningPlan,
  ActionTypesMiningPlansE,
  ActionAddMiningPlan,
  ActionDeleteMiningPlan,
} from "./actionTypes";

export function setMiningPlans(
  mining_plans: IMiningPlanOptions[] = []
): ActionSetMiningPlans {
  return {
    type: ActionTypesMiningPlansE.SET_MINING_PLANS,
    payload: { mining_plans },
  };
}

export function clearMiningPlans(): ActionBaseMiningPlans {
  return {
    type: ActionTypesMiningPlansE.CLEAR_MINING_PLANS,
  };
}

export function updateMiningPlan(
  payload: ActionUpdateMiningPlan["payload"]
): ActionUpdateMiningPlan {
  return {
    type: ActionTypesMiningPlansE.UPDATE_PLAN,
    payload,
  };
}

export function addMiningPlan(
  payload: ActionAddMiningPlan["payload"]
): ActionUpdateMiningPlan {
  return {
    type: ActionTypesMiningPlansE.ADD_PLAN,
    payload,
  };
}

export function deleteMiningPlan(
  payload: ActionDeleteMiningPlan["payload"]
): ActionDeleteMiningPlan {
  return {
    type: ActionTypesMiningPlansE.DELETE_PLAN,
    payload,
  };
}
